import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Data, Router } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { ToastColorEnum } from '../../../shared/toast/enums';
import { ToastService } from '../../../shared/toast/services/toast.service';

@Injectable()
export class HttpClientErrorInterceptor implements HttpInterceptor {
    constructor(
        private readonly router: Router,
        private readonly http: HttpClient,
        @Inject('Env') private readonly env,
        private readonly toastService: ToastService,
        @Inject('OAuthModel') private readonly oAuthModel,
    ) {
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((error) => {
            if (error.status !== 400) {
                this.checkError(error);
            }

            return throwError(error);
        }));
    }

    private checkError(error) {
        if (error.status === 401) {
            this.error401();
        } else if (error.status === 419) {
            this.error419();
        } else {
            this.errorNotifications(error);
        }
    }

    private error401() {
        this.oAuthModel.logOut();

        this.router.navigate(['/', 'sign-in']);
    }

    private error419() {
        const { token, refreshToken } = this.oAuthModel.data;

        this.http.post<Data>(this.env.refreshPath, { token, refreshToken }).toPromise().then((data) => {
            this.oAuthModel.data = { token: data.token, refreshToken: data.refreshToken };
        });
    }

    private errorNotifications(error) {
        this.toastService.open({
            title: error.name,
            color: ToastColorEnum.danger,

            description: error.error && error.error.stackTrace,
            message: error.error ? error.error.message : error.message,
        });
    }
}
